// Expedite Materials
export const SET_EXPEDITE_MATERIALS_LIST = 'SET_EXPEDITE_MATERIALS_LIST';
export const UPDATE_EXPEDITE_MATERIAL = 'UPDATE_EXPEDITE_MATERIAL';
export const ADD_EXPEDITE_MATERIAL = 'ADD_EXPEDITE_MATERIAL';
export const RESET_EXPEDITE_MATERIALS_LIST = 'RESET_EXPEDITE_MATERIALS_LIST';

// Expedite Daily Parts
export const SET_EXPEDITE_DAILY_PARTS_FILTERS = 'SET_EXPEDITE_DAILY_PARTS_FILTERS';
export const SET_EXPEDITE_DAILY_PARTS_LIST = 'SET_EXPEDITE_DAILY_PARTS_LIST';
export const ADD_EXPEDITE_DAILY_PART = 'ADD_EXPEDITE_DAILY_PART';
export const UPDATE_EXPEDITE_DAILY_PART = 'UPDATE_EXPEDITE_DAILY_PART';
export const DELETE_EXPEDITE_DAILY_PART = 'DELETE_EXPEDITE_DAILY_PART';
export const RESET_EXPEDITE_DAILY_PARTS_LIST = 'RESET_EXPEDITE_DAILY_PARTS_LIST';
export const CLEAN_EXPEDITE_DAILY_PARTS_LIST = 'CLEAN_EXPEDITE_DAILY_PARTS_LIST';

// Pagination
export const SET_PAGINATION_VALUES = 'SET_PAGINATION_VALUES';
export const UPDATE_PAGINATION_VALUES = 'UPDATE_PAGINATION_VALUES';
